import { Navigate } from "react-router-dom";
import { useAdminAuthContext } from "./useAdminAuthContext";
import { isTokenExpired  } from "../../api/helpers";

const AdminProtectedRoute = ({ children }) => {

  const { admin, authChecked } = useAdminAuthContext();
 
  if (!authChecked) {
    return <div>Loading...</div>;
  }

  if (!admin?.token || isTokenExpired(admin.token)) {
    localStorage.removeItem("admin");
    return <Navigate to="/administrator/login" replace />;
  }
  
  return children;
};

export default AdminProtectedRoute;